
<!-- ---------------------------------------New App Content Based On Theme----------------------------------------------------------------      -->
<div id="kt_app_content" class="app-content flex-column-fluid">
    <div id="kt_app_content_container" class="app-container container-xxl" *ngIf="suvDetails">
        <div class="card mb-5 mb-xxl-8">
            <div class="card-body pt-9 pb-0" [ngClass]="{'switchUserContainer':surveyService.switchUserAccess && surveyService.redirectFromCompletion}">
                <div *ngIf="surveyService.redirectFromCompletion" class="d-flex mb-2">
                    <div class="d-flex align-items-center ">
                        <div class="fs-5 fw-normal text-muted">
                            {{'Pid- '}}
                        </div>
                        <div class="fs-6 text-dark fw-normal">
                            {{surveyService.getSurveyDetailsPid()}}
                        </div>
                    </div>
                    <div class="borderPid">

                    </div>
                    <div class="d-flex align-items-center ms-2">
                        <div class="fs-5 fw-normal text-muted">
                            {{'Cags- '}}
                        </div>

                        <div class="fs-6 text-dark fw-normal">
                            {{surveyService.getCagsDeatils()}}
                        </div>
                    </div>
                </div>
                <div class="d-flex flex-wrap flex-sm-nowrap mb-6" [ngClass]="{'switchUserCard':surveyService.switchUserAccess && surveyService.redirectFromCompletion}">
                    <div class="d-flex flex-center flex-shrink-0 bg-light rounded w-100px h-100px w-lg-150px h-lg-150px me-7 mb-4">
                        <div class="Badge-Div">
                            <div *ngIf="suvDetails['name']" class="Badge-Circle-cont">{{suvDetails['name'][0] | uppercase}}</div>
                        </div>
                    </div>
                    <div class="flex-grow-1 dashboard-content">
                        <div class="d-flex justify-content-between align-items-start flex-wrap mb-2">
                            <div class="Details-Component">
                                <div class="d-flex mb-1 survey-name-div">
                                    <div>
                                        <a href="#" class="text-gray-800 text-hover-primary fs-2 fw-bold me-3">{{suvDetails.name}}</a>
                                    </div>
                                </div>
                                
                                <div style="display: flex;">
                                    <div *ngIf="surveyService.surveyDetails.test_link && surveyService.surveyDetails.test_link != '' && surveyService.accessRoles.survey && surveyService.accessRoles.survey.test_link">
                                        <button  class="btn btn-sm btn-primary me-3" (click)="getTestLinkDetails(suvDetails.test_link)">Test Link</button>
                                    </div>
                                    <div *ngIf="surveyService.surveyDetails.link && surveyService.surveyDetails.link != '' && surveyService.surveyDetails.test_link != '' && surveyService.accessRoles.survey && surveyService.accessRoles.survey.get_link">
                                        <button  class="btn btn-sm btn-primary me-3" (click)="getLinkDetails(0)">Get Link</button>
                                    </div>

                                    <div *ngIf="surveyService.showMultipleLinkAccess || (surveyService.accessRoles.survey && surveyService.accessRoles.survey.multiple_link)">
                                        <button class="btn btn-sm btn-bg-light btn-active-color-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                                            Get Multiple Links
                                        </button>
                                        <div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-250px py-3" data-kt-menu="true" >
                                            <div *ngIf="surveyService.surveyDetails.link && surveyService.surveyDetails.link != ''">
                                                <div class="menu-item px-3 d-flex justify-content-between align-items-center">
                                                    <div class="menu-content text-dark pb-2 px-3 fs-6">Link Count</div>
                                                    <input class="form-control w-100px" type="text" style="height: 30px;" [(ngModel)]="surveyService.defaultSurveyGetLink"/>
                                                </div>
                                                <div class="menu-item m-2">
                                                    <button class="menu-link px-3 btn btn-primary btn-sm text-white ms-3" (click)="getLinkDetails(1)">Generate</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                   


                                    <div *ngIf="surveyService.accessRoles.survey && surveyService.accessRoles.survey.switch_container" class="mx-3 ">
                                        <!-- <div *ngIf="surveyService.redirectFromInventory && surveyService.copy_containers_arr.length > 0">
                                            <button class="btn btn-sm btn-bg-light btn-active-color-primary" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
                                                {{surveyService.selected_container.container_name | titlecase}}
                                                ({{surveyService.selected_container.status}})
                                            </button>
                                            <div id="kt_menu_container" class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg-light-primary fw-semibold w-200px py-3" data-kt-menu="true" >
                                                <div class="details-Container-Div">
                                                    <input class="form-control" type="search" />
                                                </div>
                                                <div>
                                                    <ng-container *ngFor="let Item of surveyService.containers_arr;let i = index">
                                                        <div class="text-dark fw-bold fs-7 showAllContainers-div"
                                                        (mouseover)="changeContainerBgColor(i)"
                                                        (mouseout)="changeContainerBgColor(-1)"
                                                        (click)="switchContainerCall(Item)"
                                                        [ngClass]="{'HoveringDiv':i===containerHoverIndex}"
                                                        >
                                                            {{Item.container_name | titlecase}}({{Item.status}})
                                                        </div>
    
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div> -->
                                        
                                        <div ngbDropdown class="d-inline-block" *ngIf="surveyService.redirectFromInventory && surveyService.copy_containers_arr.length > 0"  #myDrop="ngbDropdown">
                                            <button class="btn btn-sm btn-bg-light btn-active-color-primary" id="dropdownBasic1" ngbDropdownToggle>
                                                {{surveyService.selected_container.container_name | titlecase}}
                                                ({{surveyService.selected_container.status}})
                                            </button>
                                            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                                <div class="details-Container-Div">
                                                    <input class="form-control" type="search" />
                                                </div>
                                                <div class="container_Show">
                                                    <ng-container *ngFor="let Item of surveyService.containers_arr;let i = index">
                                                        <div class="text-dark fw-bold fs-7 showAllContainers-div"
                                                        (mouseover)="changeContainerBgColor(i)"
                                                        (mouseout)="changeContainerBgColor(-1)"
                                                        (click)="switchContainerCall(Item); $event.stopPropagation(); myDrop.close()"
                                                        [ngClass]="{'HoveringDiv':i===containerHoverIndex}"
                                                        >
                                                            {{Item.container_name | titlecase}}({{Item.status}})
                                                        </div>
    
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </div>

                                        <div *ngIf="surveyService.redirectFromCompletion">
                                            <button class="btn btn-sm btn-bg-light btn-active-color-primary">
                                                {{surveyService.selected_container.container_name | titlecase}}
                                                ({{surveyService.selected_container.status}})
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                      
                        <div class="d-flex flex-wrap justify-content-start">
                            <div class="d-flex flex-wrap">
                                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                    <div class="d-flex align-items-center">
                                        <div class="fs-4 fw-bold">{{suvDetails.start || "-"}}</div>
                                    </div>
                                    <div class="fw-semibold fs-6 text-gray-400">Start Date</div>
                                </div>
                                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                    <div class="d-flex align-items-center">
                                        <div class="fs-4 fw-bold">{{suvDetails.complete || "-"}}</div>
                                    </div>
                                    <div class="fw-semibold fs-6 text-gray-400">End Date</div>
                                </div>

                                <!-- <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                    <div class="d-flex align-items-center">
                                        <div class="fs-4 fw-bold">{{suvDetails.crownit_sample_size}}</div>                                        
                                    </div>
                                    <div class="fw-semibold fs-6 text-gray-400">Exculsive Sample Size</div>
                                </div>

                                
                                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                    <div class="d-flex align-items-center">
                                        <div class="fs-4 fw-bold">{{suvDetails.total_sample_size}}</div>                                        
                                    </div>
                                    <div class="fw-semibold fs-6 text-gray-400">Shared Sample Size</div>
                                </div> -->



                                

                                
                                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                    <div class="d-flex align-items-center">
                                        <div class="fs-4 fw-bold">{{suvDetails.completes}}</div>                                        
                                    </div>
                                    <div class="fw-semibold fs-6 text-gray-400">Completes</div>
                                </div>

                                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                    <div class="d-flex align-items-center">
                                        <div class="fs-4 fw-bold">{{suvDetails.remaining_exclusive}}</div>                                        
                                    </div>
                                    <div class="fw-semibold fs-6 text-gray-400">Remaining Exclusive</div>
                                </div>

                                <div class="border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3">
                                    <div class="d-flex align-items-center">
                                        <div class="fs-4 fw-bold">{{suvDetails.remaining_shared}}</div>                                        
                                    </div>
                                    <div class="fw-semibold fs-6 text-gray-400">Remaining Shared</div>
                                </div>

                              

                                


                              
                            </div>
                           
                        </div>
                    </div>
                </div>
                <div class="separator"></div>
                <ul class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold">
                    <li class="nav-item cursor-pointer" *ngIf="surveyService.accessRoles.survey && surveyService.accessRoles.survey.details && surveyService.accessRoles.survey.details.view">
                        <a class="nav-link text-dark text-active-primary py-5 ms-6 active " (click)="detailsRouterChange()">Details</a>
                    </li>
                    <li class="nav-item cursor-pointer" *ngIf="surveyService.accessRoles.survey && surveyService.accessRoles.survey.target_group && surveyService.accessRoles.survey.target_group.view">
                        <a class="nav-link text-dark text-active-primary py-5 mx-6" (click)="tgQuotaRouterChange()">Target Group</a>
                    </li>
                    <li class="nav-item cursor-pointer" *ngIf="surveyService.accessRoles.survey && surveyService.accessRoles.survey.quota_details && surveyService.accessRoles.survey.quota_details.view">
                        <a class="nav-link text-dark text-active-primary py-5 mx-6" (click)="quotaRouterChange()">Quota Details</a>
                    </li>
                </ul>
            </div>
        </div>

        <div class="card">
            <div class="card-header">
                <div class="card-title fs-3 fw-bold">Survey Details </div>
            </div>
            <form id="kt_project_settings_form" class="form">
                <div class="card-body p-9 Details-Container">

                    <ng-container>
                        <div class="row mb-8 me-2">
                            <div class="col-xl-4">
                                <div class="fs-6 fw-semibold mt-2 mb-3">Survey Name</div>
                            </div>
                            <div class="col-xl-8 fv-row">
                                <input type="text" class="form-control form-control-solid" name="name" [(value)]="suvDetails.name" disabled/>
                            </div>
                        </div>
                        <div class="row mb-8 ms-4">
                            <div class="col-xl-4">
                                <div class="fs-6 fw-semibold mt-2 mb-3">Expected LOI (min)</div>
                            </div>
                            <div class="col-xl-8 fv-row">
                                <input type="text" class="form-control form-control-solid" name="loi" [(value)]="suvDetails.loi" disabled/>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container>
                        <div class="row mb-8 me-2">
                            <div class="col-xl-4">
                                <div class="fs-6 fw-semibold mt-2 mb-3">Expected IR (%)</div>
                            </div>
                            <div class="col-xl-8 fv-row">
                                <input type="text" class="form-control form-control-solid" name="ir" [(value)]="suvDetails.ir" disabled/>
                            </div>
                        </div>
                        <div class="row mb-8 ms-4">
                            <div class="col-xl-4">
                                <div class="fs-6 fw-semibold mt-2 mb-3">Start Date</div>
                            </div>
                            <div class="col-xl-8 fv-row">
                                <input type="text" class="form-control form-control-solid" name="start" [(value)]="suvDetails.start" disabled/>
                            </div>
                        </div>
                    </ng-container>
                    <ng-container>
                        <div class="row mb-8 me-2">
                            <div class="col-xl-4">
                                <div class="fs-6 fw-semibold mt-2 mb-3">End Date</div>
                            </div>
                            <div class="col-xl-8 fv-row">
                                <input type="text" class="form-control form-control-solid" name="complete" [(value)]="suvDetails.complete" disabled/>
                            </div>
                        </div>
                        <!-- <div class="row mb-8 ms-4">
                            <div class="col-xl-4">
                                <div class="fs-6 fw-semibold mt-2 mb-3">Shared Sample Size</div>
                            </div>
                            <div class="col-xl-8 fv-row">
                                <input type="text" class="form-control form-control-solid" name="crownit_sample_size" [(value)]="suvDetails.crownit_sample_size" disabled/>
                            </div>
                        </div> -->

                        <div class="row mb-8 ms-4">
                            <div class="col-xl-4">
                                <div class="fs-6 fw-semibold mt-2 mb-3">Completes</div>
                            </div>
                            <div class="col-xl-8 fv-row">
                                <input type="text" class="form-control form-control-solid" name="crownit_sample_size" [(value)]="suvDetails.completes" disabled/>
                            </div>
                        </div>

                    </ng-container>

                    <ng-container>
                        <div class="row mb-8 me-2">
                            <div class="col-xl-4">
                                <div class="fs-6 fw-semibold mt-2 mb-3">Remaining Exclusive</div>
                            </div>
                            <div class="col-xl-8 fv-row">
                                <input type="text" class="form-control form-control-solid" name="total_sample_size" [(value)]="suvDetails.remaining_exclusive" disabled/>
                            </div>
                        </div>
                        <div class="row mb-8 ms-4">
                            <div class="col-xl-4">
                                <div class="fs-6 fw-semibold mt-2 mb-3">Remaining Shared</div>
                            </div>
                            <div class="col-xl-8 fv-row">
                                <input type="text" class="form-control form-control-solid" name="cpi" [(value)]="suvDetails.remaining_shared" disabled/>
                            </div>
                        </div> 
                    </ng-container>



                    <ng-container>
                        <!-- <div class="row mb-8 me-2">
                            <div class="col-xl-4">
                                <div class="fs-6 fw-semibold mt-2 mb-3">Total Sample Size</div>
                            </div>
                            <div class="col-xl-8 fv-row">
                                <input type="text" class="form-control form-control-solid" name="total_sample_size" [(value)]="suvDetails.total_sample_size" disabled/>
                            </div>
                        </div> -->
                        <div class="row mb-8 me-2" *ngIf="suvDetails.research_type">
                            <div class="col-xl-4">
                                <div class="fs-6 fw-semibold mt-2 mb-3">Research Type</div>
                            </div>
                            <div class="col-xl-8 fv-row">
                                <input type="text" class="form-control form-control-solid" name="research_type" [(value)]="suvDetails.research_type" disabled/>
                            </div>
                        </div>
                        <div class="row mb-8 ms-4">
                            <div class="col-xl-4">
                                <div class="fs-6 fw-semibold mt-2 mb-3">CPI</div>
                            </div>
                            <div class="col-xl-8 fv-row">
                                <input type="text" class="form-control form-control-solid" name="cpi" [(value)]="suvDetails.cpi" disabled/>
                            </div>
                        </div> 
                    </ng-container>
                    <ng-container>

                        <div class="row mb-8 me-2" *ngIf="suvDetails.job_id">
                            <div class="col-xl-4">
                                <div class="fs-6 fw-semibold mt-2 mb-3">JOB ID</div>
                            </div>
                            <div class="col-xl-8 fv-row">
                                <input type="text" class="form-control form-control-solid" name="job_id" [(value)]="suvDetails.job_id" disabled/>
                            </div>
                        </div>

                        <div class="row mb-8 ms-4" *ngIf="suvDetails.contact_email_address">
                            <div class="col-xl-4">
                                <div class="fs-6 fw-semibold mt-2 mb-3">Contact Email Address</div>
                            </div>
                            <div class="col-xl-8 fv-row">
                                <input type="text" class="form-control form-control-solid" name="contact_email_address" [(value)]="suvDetails.contact_email_address" disabled/>
                            </div>
                        </div>
                        
                    
                    </ng-container>


                    <ng-container>
                        <div class="row mb-8 me-2" *ngIf="suvDetails.secondary_project_manager">
                            <div class="col-xl-4">
                                <div class="fs-6 fw-semibold mt-2 mb-3">Primary Project Manager</div>
                            </div>
                            <div class="col-xl-8 fv-row">
                                <input type="text" class="form-control form-control-solid" name="primary_project_manager" [(value)]="suvDetails.primary_project_manager" disabled/>
                            </div>
                        </div>
                        <div class="row mb-8 ms-4" *ngIf="suvDetails.secondary_project_manager">
                            <div class="col-xl-4">
                                <div class="fs-6 fw-semibold mt-2 mb-3">Secondary Project Manager</div>
                            </div>
                            <div class="col-xl-8 fv-row">
                                <input type="text" class="form-control form-control-solid" name="secondary_project_manager" [(value)]="suvDetails.secondary_project_manager" disabled/>
                            </div>
                        </div>

                    </ng-container>

                    <ng-container>
                        
                        <div class="row mb-8 me-2" *ngIf="suvDetails.assigned_clients">
                            <div class="col-xl-4">
                                <div class="fs-6 fw-semibold mt-2 mb-3">Assigned Clients</div>
                            </div>
                            <div class="col-xl-8 fv-row">
                                <input type="text" class="form-control form-control-solid" name="assigned_clients" [(value)]="suvDetails.assigned_clients" disabled/>
                            </div>
                        </div>
                    </ng-container>  
                </div>
            </form>
        </div>
    </div>
</div>
